/**
 * ONYX Logo — uses the official logo image.
 * variant="dark"  → original dark logo (for white backgrounds)
 * variant="light" → inverted via CSS filter (for dark backgrounds)
 */
const LOGO_SRC = "https://customer-assets.emergentagent.com/job_onyx-premium-reserve/artifacts/p77yput3_b623322b-3f2f-464f-8186-10972c9259c3.png";

const SIZE_MAP = {
  sm: "h-9",
  md: "h-12 md:h-14",
  lg: "h-20 md:h-24",
  xl: "h-32 md:h-40",
};

export default function Logo({ variant = "dark", size = "md", className = "" }) {
  const isLight = variant === "light";
  return (
    <img
      data-testid="onyx-logo"
      src={LOGO_SRC}
      alt="Onyx Rooftop Lounge"
      className={`${SIZE_MAP[size] || SIZE_MAP.md} w-auto select-none ${className}`}
      style={{
        // Invert the dark logo to white for dark backgrounds
        filter: isLight ? "invert(1) brightness(1.1)" : "none",
      }}
      draggable={false}
    />
  );
}
